(function () {
  'use strict';

  function normalizeBuyNow(root) {
    root.querySelectorAll('.shopify-payment-button__button').forEach(function (btn) {
      if (/buy it now/i.test(btn.textContent.trim())) {
        btn.textContent = 'Buy Now';
      }
    });
  }

  function init() {
    var layout = document.querySelector('.taupe-product-layout');
    if (!layout) return;

    normalizeBuyNow(layout);

    if (typeof MutationObserver === 'undefined') return;

    new MutationObserver(function () {
      normalizeBuyNow(layout);
    }).observe(layout, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
